export const unit = 8

export const EDU_LEVELS_SLUG = 'edu'
export const POST_SLUG = 'post'
export const POSTS_SLUG = 'posts'
export const ALUMNUS_SLUG = 'alumnus'
export const ALUMNI_SLUG = 'alumni'
export const REGISTRATION_SLUG = 'registrations'
export const EDU_PAGE_SLUG = 'edu/page'
export const PAGE_SLUG = 'page'
export const GREEK_LANG = 'el'
export const ENGLISH_LANG = 'en'
export const LIGHT_THEME = 'light'
export const DARK_THEME = 'dark'

export const greekLanguage = 'el'
export const englishLanguage = 'en'

export const breakpoints = [576, 768, 960, 1200, 1536]

export const screenSizes = {
    xl: 1199,
    lg: 959,
    md: 768,
    sm: 576,
}

// export const screenSizes = {
//     xl: 1440,
//     lg: 1024,
//     md: 768,
//     sm: 414,
// }

export const fontFamily = {
    sourceSans:
        'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,400;0,700;0,900;1,400&display=swap',
}

export const fontWeights = {
    light: 200,
    regular: 400,
    semibold: 700,
    bold: 900,
    inherit: 'inherit',
}


export const ContentTypeSlugMap = {
    'ContentfulEduPage': 'edu/page',
    'ContentfulPage': 'page',
    'ContentfulLayoutPage': 'l',
    'ContentfulEducationalLevels': 'edu',
}
